import React from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header/Header';
import Contact from '../components/Contact';


const ContactPage = () => {
    return (
        <>
            <Header />
            <Contact/>
            <Footer />
        </>
    )
}

export default ContactPage;